/**
 * Validates a phone number string.
 * Allows empty. If provided, must contain only digits, spaces, dashes, parens, plus, dots,
 * and have at least 7 digits.
 * Returns an error string or null if valid.
 */
export function validatePhone(value) {
    if (!value || !value.trim()) return null;
    const trimmed = value.trim();
    if (!/^[\d\s\-()+.]+$/.test(trimmed)) {
        return 'Phone may only contain digits, spaces, dashes, parentheses, +, and dots';
    }
    const digitCount = (trimmed.match(/\d/g) || []).length;
    if (digitCount < 7) {
        return 'Phone number must have at least 7 digits';
    }
    if (digitCount > 15) {
        return 'Phone number must have at most 15 digits';
    }
    return null;
}

/**
 * Validates an email string.
 * Allows empty. If provided, must be a valid email format.
 * Returns an error string or null if valid.
 */
export function validateEmail(value) {
    if (!value || !value.trim()) return null;
    // Basic email regex — covers standard cases without being overly strict
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!re.test(value.trim())) {
        return 'Please enter a valid email address';
    }
    return null;
}

/**
 * Validates a date string (YYYY-MM-DD).
 * Allows empty. If provided, must not be in the future and not before 1900.
 * @param {string} value - date string
 * @param {string} label - field label for error messages (e.g. "Birthdate")
 * Returns an error string or null if valid.
 */
export function validateDate(value, label) {
    if (!value || !value.trim()) return null;
    const parsed = new Date(value + 'T00:00:00');
    if (isNaN(parsed.getTime())) {
        return `${label} is not a valid date`;
    }
    const year = parsed.getFullYear();
    if (year < 1900) {
        return `${label} must be after 1900`;
    }
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    if (parsed > today) {
        return `${label} cannot be in the future`;
    }
    return null;
}
